import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Configuration axios - determine environment
const isProduction = window.location.hostname !== 'localhost';
axios.defaults.baseURL = isProduction ? '/api' : 'http://localhost:5001/api';
axios.defaults.withCredentials = true;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({ 
    id: 'admin123',
    name: 'Administrateur',
    email: 'admin@gymit.dz',
    role: 'admin'
  });
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState('auto-auth-token');

  // Configure axios interceptor for token
  useEffect(() => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }, [token]);

  // Auto-authenticate on app load
  useEffect(() => {
    setLoading(false);
  }, []);

  // Login function is kept for potential future use
  const login = async (credentials) => {
    return { success: true };
  };

  const logout = () => {
    // No actual logout needed, but keeping the function for API compatibility
    toast.success('Déconnexion réussie');
  };

  const updateUser = (userData) => {
    setUser(userData);
  };

  const value = {
    user,
    loading,
    login,
    logout,
    updateUser,
    isAuthenticated: true, // Always authenticated
    isAdmin: true, // Always admin
    isStaff: true, // Always staff
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}; 